class CompanySchema {
  constructor() {
    this.fields = {
      type: {
        label: "Typ",
        validation: {
          minLength: 1,
          maxLength: 6,
        },
        required: true,
        type: "text",
        fieldType: "select",
        options: [
          { key: "sc", value: "Schule" },
          { key: "st", value: "Schulstiftung" },
        ],
        initialValue: "sc",
      },
      name: {
        label: "Name",
        initialValue: "",
        validation: {
          minLength: 3,
        },
        required: true,
        type: "text",
        fieldType: "textarea",
        placeholder: "Name",
      },
      homepage: {
        label: "Homepage",
        initialValue: "",
        validation: {
          maxLength: 120,
        },
        type: "text",
        fieldType: "text",
        placeholder: "Homepage",
      },
      schoolnumber: {
        label: "Schulnummer",
        initialValue: "",
        validation: {
          maxLength: 10,
        },
        type: "text",
        fieldType: "text",
        placeholder: "Schulnummer",
      },
      address: {
        label: "Adresse",
        initialValue: "",
        type: "text",
        fieldType: "textarea",
        placeholder: "Adresse",
      },
      city:{
        
        label: "Stadt",
        initialValue: "",
        validation: {
          maxLength: 30,
        },
        fieldType: "text",
    },      
      land:{
        
          label: "Bundesland",
          initialValue: "Berlin",
          validation: {
            maxLength: 30,
          },
          fieldType: "select",
          options: [
            { key: "Berlin", value: "Berlin" },
            { key: "Brandenburg", value: "Brandenburg" },
          ],
      },


    };
  }
}

export default CompanySchema;
